import Axios from '../lib/axios'
import AxiosForMobile from '../lib/axios_for_mobile'
import store from '@/store'

class PatientService {
  async index () {
    const result = await Axios.authenticated().get('/patients', {})
    return result
  }

  async indexForMobile () {
    const result = await AxiosForMobile.authenticated().get('/b/patients', {})
    return result
  }

  async byId (id) {
    const result = await Axios.authenticated().get(`/patients/${id}`, {})
    return result
  }

  async drugSearch (filters) {
    const result = await Axios.authenticated().get(`/patients/drug-search`, { params: filters })
    return result
  }

  async patientStats (filters) {
    const result = await Axios.authenticated().get(`/patients/patient-stats`, { params: filters })
    return result
  }

  async create (patient) {
    let config = {
      onUploadProgress: e => store.state.currentProgress = Math.round(e.loaded * 100 / e.total)
    }
    const result = await Axios.authenticated().post(
      `/patients`,
      patient,
      config
    )
    return result
  }

  async update (patientId, payload) {
    const result = await Axios.authenticated().put(`/patients/${patientId}`, payload)
    return result
  }

  async delete (patientId) {
    const result = await Axios.authenticated().delete(`/patients/${patientId}`)
    return result
  }
}

export default new PatientService()
